export const priorityOptions = ["Non Urgent", "Important", "Urgent"];
export const priorityOptionsAll = ["All", "Non Urgent", "Important", "Urgent"];
export const pageLimit = 999999;
